import { Button } from "@common/index";
import styles from "./styles.module.scss";
import img from "./img/img.png";

export const SleepIsKey = ({ onNextStep, onTrackEvent }) => {
  return (
    <div id="breakdown" className={styles.container}>
      <div className={styles.content}>
        <img src={img} alt="slimdown" className={styles.image} />
        <div className={styles.hints}>
          <h4>Sleep is key for weight loss</h4>
          <p className={styles.description}>
            Good sleep helps improve metabolism, control appetite, and reduce
            cravings, and it gives you more energy. <br/> By supporting hormonal
            health and digestion along with weight loss, somatic workouts can
            help you get a <strong>good night's rest.</strong>
          </p>
          <p className={styles.descriptionSecond}>
            *Information sourced from "National Library of medicine"
          </p>
        </div>
      </div>
      <Button
        variant="walky"
        onClick={() => {
          onNextStep();
          onTrackEvent();
        }}
      >
        Continue
      </Button>
    </div>
  );
};
